module.exports = __webpack_public_path__ + "media/assets/images/blog/fixing_board-615a202583aaab6d6e1a62155608cd1c.jpeg";